import Button from "common/components/Button/Button"
import FormikAutoComplete from "common/components/FormikFields/FormikAutoComplete"
import FormikInputText from "common/components/FormikFields/FormikInputText"
import { DEFAULT_COUNTRY_SELECTED, countries } from "common/constants/countries"
import useRazonSocialAndCif from "common/hooks/useRazonSocialAndCif"
import useSearchEmpresa from "common/hooks/useSearchEmpresa"
import * as Validations from "common/utils/formValidations"
import {
  contactFormTaxesMapper,
  validateFormTabs,
} from "features/Contactos/constants"
import FormDatosBasicos from "features/Contactos/forms/DatosBasicos"
import FormEmailPhone from "features/Contactos/forms/EmailPhone"
import { editCuentasBancarias } from "features/Contactos/redux/slices/contactoSlice"
import { resetApprovals } from "features/User/redux/slices/approvalSlices"
import { withFormik } from "formik"
import { useDispatch } from "hooks/useDispatch"
import { useEffect, useState } from "react"
import ReactFlagsSelect from "react-flags-select"
import { useTranslation } from "react-i18next"
import * as Yup from "yup"

const CrearContactoForm = ({
  values,
  setFieldValue,
  handleSubmit,
  onHide,
  isValid,
  dirty,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const [tabSelected, setTabSelected] = useState(0)
  const dispatch = useDispatch()
  const {
    cifs,
    razonesSociales,
    getByCifOrRazonSocial,
    getRazonSocialByCif,
    getCifByRazonSocial,
  } = useRazonSocialAndCif()
  // @ts-expect-error TS(2345): Argument of type '() => () => { payload: undefined...
  useEffect(() => {
    return () => {
      return dispatch(resetApprovals())
    }
  }, [dispatch])

  useEffect(() => {
    dispatch(editCuentasBancarias(values.cuentasBancarias))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const { searchingEmpresa, searchEmpresaByNif } = useSearchEmpresa({
    onSearchEmpresa: (empresa: $TSMigrationFixMe) => {
      setFieldValue("direccion", empresa.direccion?.calle)
      setFieldValue("cp", empresa.direccion?.codigoPostal)
      setFieldValue("poblacion", empresa.direccion?.poblacionNombre)
      setFieldValue("poblacionId", empresa.direccion?.poblacionId)
      setFieldValue("provinciaId", empresa.direccion?.provinciaId)
      setFieldValue("provincia", empresa.direccion?.provincia)
    },
  })

  const handleOnSelectCif = (e: $TSMigrationFixMe) => {
    setTimeout(() => setFieldValue("cif", e.value), 50)
    const razonSocial = getRazonSocialByCif(e.value)
    setFieldValue("razonSocial", razonSocial)
    searchEmpresaByNif(e.value)
  }

  const handleOnSelectRazonSocial = (e: $TSMigrationFixMe) => {
    setFieldValue("razonSocial", e.value)
    const cif = getCifByRazonSocial(e.value)
    setFieldValue("cif", cif)
    searchEmpresaByNif(cif)
  }

  const tabToRedirect = () => {
    const invalidTabs = validateFormTabs(values).filter(
      ({ invalid }) => invalid
    )

    const currentTabIsInvalid = invalidTabs.find(({ id }) => id === tabSelected)

    return currentTabIsInvalid || invalidTabs.length === 0
      ? tabSelected
      : invalidTabs[0].id
  }

  return (
    <div className='crear-contacto'>
      <form
        onSubmit={handleSubmit}
        className='w-100 d-flex flex-column'
      >
        <section>
          <div className='mt-3 text-left p-fluid p-formgrid'>
            <div className='p-field selected-country-mix-cif'>
              <label htmlFor='cif'>{t("contactos.crear.labelCif")}</label>
              <ReactFlagsSelect
                disabled={searchingEmpresa}
                // @ts-expect-error TS(2322): Type '{ disabled: boolean; name: string; className...
                name='codigoPais'
                className='selected-country-mix-cif__select-country-field'
                onSelect={(code) => setFieldValue("codigoPais", code)}
                searchable
                selected={values.codigoPais || DEFAULT_COUNTRY_SELECTED}
                customLabels={countries}
                searchPlaceholder={`${t("contactos.crear.placeholderCif")}`}
                showSelectedLabel={false}
              />

              <FormikAutoComplete
                disabled={searchingEmpresa}
                className='selected-country-mix-cif__input-cif-field'
                value={values?.cif}
                isCif
                id='cif'
                name='cif'
                completeMethod={(query: $TSMigrationFixMe) =>
                  getByCifOrRazonSocial("cif", query)
                }
                suggestions={cifs}
                onSelect={handleOnSelectCif}
              />
            </div>

            <div className='p-field'>
              <label htmlFor='razonSocial'>
                {t("contactos.crear.labelCompanyName")}
              </label>

              {values.codigoPais === DEFAULT_COUNTRY_SELECTED ? (
                <FormikAutoComplete
                  disabled={searchingEmpresa}
                  id='razonSocial'
                  name='razonSocial'
                  completeMethod={(query: $TSMigrationFixMe) => {
                    getByCifOrRazonSocial("razonSocial", query)
                  }}
                  suggestions={razonesSociales}
                  onSelect={handleOnSelectRazonSocial}
                />
              ) : (
                <FormikInputText
                  disabled={searchingEmpresa}
                  id='razonSocial'
                  name='razonSocial'
                />
              )}
            </div>
          </div>

          <FormDatosBasicos
            values={values}
            setFieldValue={setFieldValue}
          />

          <FormEmailPhone />
        </section>

        <div
          onClick={() => setTabSelected(tabToRedirect())}
          className='mt-4 mr-1 row justify-content-end align-items-center'
        >
          <Button
            className='mr-3 large text'
            onClick={onHide}
          >
            {t("contactos.crear.labelCancel")}
          </Button>
          <Button
            type='submit'
            className='!tw-bg-secondary hover:!tw-bg-secondary-over !tw-border-none tw-cursor-pointer tw-py-3 tw-px-5'
            disabled={!(isValid && dirty)}
          >
            {t("contactos.crear.labelAddContact")}
          </Button>
        </div>
      </form>
    </div>
  )
}

export const validationSchema = (t: $TSMigrationFixMe) =>
  Yup.object().shape({
    razonSocial: Validations.validateRazonSocial(t),
    cif: Yup.string()
      .when("codigoPais", {
        is: DEFAULT_COUNTRY_SELECTED,
        then: Validations.validateCif(t),
      })
      .required(t("errors.cifEmpty")),
    poblacion: Yup.string().when("codigoPais", {
      is: DEFAULT_COUNTRY_SELECTED,
      then: Validations.validatePoblacion(t),
    }),
    cp: Yup.string().when("codigoPais", {
      is: DEFAULT_COUNTRY_SELECTED,
      then: Validations.validateCodigoPostal(t),
    }),
    direccion: Validations.validateDireccion(t),
    email: Validations.validateEmail(t),
    telefono: Validations.validateTelefonoNotRequired(t),
  })

export const validateFn = (
  t: $TSMigrationFixMe,
  { codigoPais, poblacionId }: $TSMigrationFixMe
) => {
  const errors = {}

  if (!poblacionId && codigoPais === DEFAULT_COUNTRY_SELECTED) {
    // @ts-expect-error TS(2339): Property 'poblacionId' does not exist on type '{}'...
    errors.poblacionId = `${t("errors.selectedPoblation")}`
  }
  return errors
}

const Form = withFormik({
  validateOnMount: true,
  // @ts-expect-error TS(2339): Property 'data' does not exist on type '{}'.
  mapPropsToValues: ({ data, taxes }) => {
    return {
      cif: data?.cif,
      razonSocial: data?.razonSocial,
      poblacion: data?.poblacion || "",
      poblacionId: data?.poblacionId || "",
      cp: data?.cp,
      direccion: data?.direccion,
      codigoPais: data?.pais || DEFAULT_COUNTRY_SELECTED,
      poblacionExtranjera: data?.poblacionExtranjera,
      email: data?.email,
      telefono: data?.telefono,
      // @ts-expect-error TS(2554): Expected 3 arguments, but got 2.
      ...(data && contactFormTaxesMapper(data, taxes)),
    }
  },
  // @ts-expect-error TS(2339): Property 't' does not exist on type '{}'.
  validate: (rowData, { t }) => validateFn(t, rowData),
  enableReinitialize: true,
  validationSchema: ({ t }: $TSMigrationFixMe) => validationSchema(t),
  handleSubmit: async (values, { props }) => {
    // @ts-expect-error TS(2339): Property 'updateData' does not exist on type 'obje...
    props.updateData(values)
  },
})(CrearContactoForm)

export default Form
